export default "__VITE_ASSET__62fda569__"